import React from "react";

import { Container, Image } from "./styles";

function Loading() {
  return (
    <Container>
      <Image src="/bradescoexclusive/assets/loading.svg" alt="Carregando" />
    </Container>
  );
}

export default Loading;
